import http from './http';
import CrudApi from './crud';

export const crud = new CrudApi('/admin/assignmenttypes');

export function updateWeights(payload) {
	return http.put('/admin/assignmenttypes/weights', payload).then(resp => resp.data);
}
